import * as React from 'react';
import { DeleteForm } from '../DeleteForm';
import { useBankAccountDeleteForm } from './useBankAccountDeleteForm';
import { Originate } from '../../../Model/Originate';

export const BankAccountDeleteForm = () => {
  const { onSubmit, isLoading, originate } = useBankAccountDeleteForm();
  return (
    <DeleteForm
      onSubmit={onSubmit}
      inProgress={isLoading}
      headerText={
        originate === Originate.SZAMLAZZHU
          ? 'A bankszámla törlése nem elégséges. Bizonyosodjon meg róla, hogy a szamlazz.hu oldalán is megszűnt a kapcsolat, különben a bankszámla újra létrejön.'
          : 'Biztos hogy törli ezt a bankszámlát?'
      }
      submitText={'Törlés'}
    />
  );
};
